import cn from 'classnames';
import style from './style.scss';

type RailPosition = 'right' | 'left';

interface RailProps {
  position: RailPosition;
  className?: string;
  children: JSX.Element | JSX.Element[] | string;
}

export const Rail = ({ position, className, children }: RailProps) => (
  <div
    className={cn(
      style.rail,
      {
        [style.right]: position === 'right',
        [style.left]: position === 'left'
      },
      className
    )}
  >
    {children}
  </div>
);
